<template>
  <div>
    <input
      type="text"
      v-model="macInput"
      class="mac-address-input"
      @input="validateInput"
      placeholder="Enter MAC Address"
    />
  </div>
</template>

<script>
import MacAddress from '@/helpers/macaddress.js';

export default {
  data() {
    return {
      macInput: '',
      isInvalid: false,
    };
  },
  methods: {
    validateInput() {
      this.isInvalid = false;  // reset

      if (this.macInput.trim() === '') return;  // Do nothing for empty input

      try {
        const macInstance = new MacAddress(this.macInput);
        this.$log.onDebug("Valid mac")
        this.macInput = macInstance.address
        this.$emit('validMacAddress', macInstance);
      } catch (err) {
        this.$log.onError('invalid')
        this.$emit('invalidMacAddress');
        this.isInvalid = true;
      }
    }
  }
}
</script>

<style scoped>
.invalid-border {
  border: 1px solid red;
}

.mac-address-input {
  border-radius: 6px !important;
  width: 16rem;
}
</style>
